/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from '@mui/material';
import React, { useState } from 'react';
import EditableCard from 'modules/common/editableCard.component';
import {
  createCustomExceptionFormData,
  createCustomExceptionTabs,
  createCustomInfoFormData,
  createCustomInfoPutRequest,
  createCustomInfoTabs
} from './customExpenseLinesUtils';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { withStyles } from '@material-ui/core';
import { showToast } from 'modules/layout/layout.actions';
import { DRAWER_WIDTH_CLOSED, DRAWER_WIDTH_CLOSED_XS, DRAWER_WIDTH_OPEN } from 'styles/theme';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  container: {
    height: 'auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    whiteSpace: 'nowrap',
    width: `calc(100% - ${DRAWER_WIDTH_CLOSED_XS}px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${DRAWER_WIDTH_CLOSED}px)`
    }
  },
  drawerOpen: {
    width: `calc(100% - ${DRAWER_WIDTH_OPEN})`
  },
  headerFixed: {
    zIndex: 4
  },
  tabFixed: {
    paddingTop: '100px',
    zIndex: 3
  },
  estimateHeaderFixed: {
    paddingTop: '150px',
    zIndex: 2
  }
});

const ExpenseLineItemCustomView = props => {
  const { expenseLineItemDetails, enumerations, onUpdateApprovedLineItemDetails, isReadOnly } = props;

  const [isLoading, setIsLoading] = useState(false);

  const onHandleUpdateExpenseLineItem = async request => {
    setIsLoading(true);
    const response = await onUpdateApprovedLineItemDetails(request);
    if (!response) {
      props.showToast('Failed to update the expense line item, please try again.', {
        severity: TOAST_MESSAGE_SEVERITY_ERROR
      });
      setIsLoading(false);
      return false;
    }
    setIsLoading(false);
    return true;
  };

  const onHandleUpdateCustomInfo = async (tab, values) => {
    let request = createCustomInfoPutRequest(expenseLineItemDetails, values);
    return await onHandleUpdateExpenseLineItem(request);
  };

  return (
    <Grid container spacing={2} sx={{ padding: '20px' }}>
      <Grid item sm={12} md={12} lg={8} xl={8} sx={{ display: 'flex', flexDirection: 'column', height: 'auto', alignSelf: 'flex-start' }}>
        <EditableCard
          tabs={createCustomInfoTabs()}
          summaries={createCustomInfoFormData(expenseLineItemDetails, enumerations)}
          numColumns={5}
          updateFields={onHandleUpdateCustomInfo}
          isLoading={isLoading}
          hideEdit={isReadOnly}
        />
      </Grid>
      <Grid item sm={12} md={12} lg={4} xl={4}>
        <Grid container direction="column" spacing={2}>
          {/* <Grid item>
            <CustomExpenseDetailsCurrencyEditableCardComponent
              selectedExpenseLineItem={expenseLineItemDetails}
              updateFields={onHandleUpdateCustomCurrency}
              isLoading={isLoading}
              enumerations={enumerations}
            />
          </Grid> */}
          <Grid item>
            <EditableCard
              tabs={createCustomExceptionTabs()}
              summaries={createCustomExceptionFormData()}
              updateFields={() => console.log('I am actually a read only table.')}
              numColumns={3}
              hideEdit={true}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = state => {
  return {
    shouldShowSideDrawer: state.layout.shouldShowSideDrawer
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    showToast
  })
)(ExpenseLineItemCustomView);
